import React from 'react'


import arrowStyles from './arrow.module.scss'

export const ArrowUp = () => (
    <svg width="10px" height="10px" viewBox="0 0 180 80" version="1.1" className={arrowStyles.arrow}>
        <desc>Created with Sketch.</desc>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <polyline stroke="currentColor" strokeWidth="20" fillRule="nonzero"
                      points="2 76 85.0039062 4 168.007812 76"></polyline>
        </g>
    </svg>
);

export const ArrowDown = () => (
    <svg width="10px" height="10px" viewBox="0 0 180 80" version="1.1" className={arrowStyles.arrow}>
        <desc>Created with Sketch.</desc>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <polyline stroke="currentColor" strokeWidth="20" fillRule="nonzero"
                      transform="translate(90.003906, 44.000000) scale(1, -1) translate(-90.003906, -44.000000) "
                      points="7 80 90.0039062 8 173.007812 80"></polyline>
        </g>
    </svg>
);

